/*
 *  I14V2VREGULCalcul.js
 *
 *  Created by Sébastien Hecart on 2017-12-19 16:48:07 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

import { fetchPerteChargeUnite } from '@batical/data/src'
import { I14V2VREGUL_State } from '@batical/types/src'

function I14V2VREGUL_docalcul(state: I14V2VREGUL_State) {
  state.invalidated = false
  let selected = fetchPerteChargeUnite(state.perteCharg_uuid)
  //TODO CALCUL
  state.res_pdcVanne = ((Math.pow(state.in_debitCircuit / state.in_kvVanne, 2) * 98) / 0.001) * selected.factor
  return state
}

export default I14V2VREGUL_docalcul
